import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Text, TextType } from 'ui-components/components/text';

import { useEntitiesSalesOrderProperty } from '../../../../../../../hooks/entities/selectors/sales-orders';
import { useSalesOrderIdContext } from '../../../../../../context/sales-order-id-context-provider';
import messages from '../../messages';

export const RemoveShipmentBanner = () => {
  const salesOrderId = useSalesOrderIdContext();
  const orderNumber = useEntitiesSalesOrderProperty(salesOrderId, 'orderNumber');

  return (
    <BannerMessageV2
      content={
        <Text
          formattedMessageValues={{
            orderNumber,
            b: (chunks) => <b>{chunks}</b>,
          }}
          textType={TextType.Label}
          value={messages.removeShipmentBanner}
        />
      }
      status={BannerStatus.Info}
    />
  );
};
